import React, { useContext, useState } from "react";
import Checkbox from "../../../../molecules/formComponents/checkbox/Checkbox";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import UnfilledButton from "../../../../molecules/buttons/unfilledButton/UnfilledButton";
import FilledButton from "../../../../molecules/buttons/filledButton/FilledButton";
import AppContext from "../../../../../context/AppContext";
import { cancelSubscriptionRenewalApi } from "../../../../../api/AccountApi";
import { defaultValidation } from "../../../../../utils/formValidation/FormValidation";

function CancelAutoRenewalModal({ subscriptionUuid, callback = async () => {} }) {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { setModalContent, setModalVisible, createNotification } = useContext(AppContext);

  const [isButtonLoading, setIsButtonLoading] = useState(false);

  async function formSubmit() {
    setIsButtonLoading(true);
    try {
      await cancelSubscriptionRenewalApi(subscriptionUuid);
      await callback();
      createNotification(
        <>Le renouvellement automatique de votre abonnement a été désactivé avec succès.</>,
        "var(--green)",
        "var(--dark-blue)",
      );
      setModalVisible(false);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;

        if (errorMessage.includes("La résiliation est possible uniquement entre")) {
          const datesMatch = errorMessage.match(/(\d{4}-\d{2}-\d{2})/g);
          let startDateStr = "";
          let endDateStr = "";

          if (datesMatch && datesMatch.length >= 2) {
            startDateStr = datesMatch[0].split("-").reverse().join("/");
            endDateStr = datesMatch[1].split("-").reverse().join("/");
          }

          setModalContent({
            title: "Période de résiliation spécifique",
            content: (
              <div>
                <p>
                  Votre abonnement ne peut être résilié que pendant une période spécifique, entre le {startDateStr} et
                  le {endDateStr} inclus.
                </p>
                <p>En dehors de cette période, le renouvellement automatique ne peut pas être désactivé.</p>
                <div className='modal-buttons-row'>
                  <FilledButton padding='10px 20px' onClick={() => setModalVisible(false)}>
                    Compris
                  </FilledButton>
                </div>
              </div>
            ),
          });
        } else {
          createNotification(
            <>
              Une erreur est survenue lors de l'annulation du renouvellement de votre abonnement. Veuillez réessayer.
            </>,
            "var(--red)",
            "var(--dark-blue)",
          );
          setModalVisible(false);
        }
      } else {
        createNotification(
          <>Une erreur est survenue lors de l'annulation du renouvellement de votre abonnement. Veuillez réessayer.</>,
          "var(--red)",
          "var(--dark-blue)",
        );
        setModalVisible(false);
      }
    } finally {
      setIsButtonLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit(formSubmit)}>
      <Checkbox
        useForm={{ register, setValue }}
        error={errors?.message?.message}
        name='message'
        validation={defaultValidation}
        label={
          <p>
            Conformément aux <Link to='/cgv'>conditions générales de vente</Link>, j'ai accès à toutes les
            fonctionnalités du site jusqu'à l'expiration de ma période d'engagement, durant laquelle mon règlement de
            l'abonnement se poursuivra dans les mêmes conditions qu'actuellement.
          </p>
        }
      />
      <div className='modal-buttons-row'>
        <UnfilledButton padding='10px 20px' onClick={() => setModalVisible(false)}>
          Annuler
        </UnfilledButton>
        <FilledButton isLoading={isButtonLoading} padding='10 20px' type='submit'>
          Confirmer
        </FilledButton>
      </div>
    </form>
  );
}

export default CancelAutoRenewalModal;
